import GeneralInformation from "./GeneralInformation";
import { applyPropertyControls } from "../../property-controls";
import { contentBoxPropertyControls } from "../../ContentBox";

applyPropertyControls(GeneralInformation, {
	boxProps: contentBoxPropertyControls
});

export default GeneralInformation;
